import {Component} from "./Component";
import {delayPromise} from "../util/promise";
import {fetchPage} from "../util/ajax";
import {filterEventSelector} from "../util/event";
import {createLogger} from "../util/logger";
import {hideLoader, showLoader} from "../loader";
import {getParent} from "../util/dom";
import {ScrollAnimations} from "./ScrollAnimations";
import {Scroll} from "./Scroll.js";

const console = createLogger("AjaxPagination");

export class AjaxPagination extends Component {
    static name = "ajax-pagination";

    static EVENT_LOAD_START = "ajax-pagination:load-start";
    static EVENT_LOAD_END = "ajax-pagination:load-end";


    get name() {
        return AjaxPagination.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement}
         */
        this.$target = this.$("target");

        this.$loader = this.$("loader");

        this.currentUrl = window.location.href;

        this.addEventListener(this.el, "click",
            filterEventSelector(this.getAttributeSelector("nextPageLink"), this.onClickNextPage.bind(this))
        );

        this.isReplace = el.hasAttribute(this.getComponentAttributeName("replace"));
        console.log(this);
    }

    /**
     * @param {MouseEvent} e
     */
    onClickNextPage(e) {
        e.preventDefault();
        e.stopPropagation();

        const el = getParent(e.target, this.getAttributeSelector("nextPageLink"));
        const url = el.getAttribute("href");

        console.log("onClickNextPage", el, url);

        return this.loadPage(url);
    }

    /**
     *
     * @param {string} url
     */
    loadPage(url) {
        this.currentUrl = url;
        this.dispatchDomEvent(AjaxPagination.EVENT_LOAD_START, {
            url,
        });

        // Show loader
        document.body.classList.add("ajax-pagination--pending");

        if (this.$loader) showLoader(this.$loader);

        // Fetch Page
        return delayPromise(0, fetchPage(url)).then((html) => {
            this.renderHtml(html);

            document.body.classList.remove("ajax-pagination--pending");
            if (this.$loader) hideLoader(this.$loader);

            this.dispatchDomEvent(AjaxPagination.EVENT_LOAD_END, {
                url,
                target: this.$target,
            });
        });
    }

    renderHtml(html) {
        const $source = html.querySelector(this.getAttributeSelector("target"));

        console.log("loadPage.result", {name: this.getAttributeSelector("target"), $source, html});


        if (!$source) return;

        if (this.isReplace) {
            this.$target.replaceChildren(...$source.children);
        } else {
            this.$target.append(...$source.children);
        }

        ScrollAnimations.updateAnimations(this.$target.parentElement || this.$target);

        const replaceAttrName = this.getComponentAttributeName("replace");
        const $replaceSource = Array.from(html.querySelectorAll(`[${replaceAttrName}]`));

        console.log("replaceSource", replaceAttrName, $replaceSource);

        $replaceSource.forEach((sourceElement) => {
            const name = sourceElement.getAttribute(replaceAttrName);
            if (!name?.length) return;

            const targetElement = this.el.querySelector(`[${replaceAttrName}="${name}"]`);

            if (targetElement) {
                console.log("replace", {targetElement, sourceElement})
                targetElement.replaceChildren(...sourceElement.children);
                ScrollAnimations.updateAnimations(targetElement);
            }
        });

        ScrollAnimations.updateAnimations(this.$target);
    }


    refresh() {
        this.loadPage(this.currentUrl);
    }
}
